import { tw } from "@careinfo/tailwind";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const Modal = (props: any) => {
  const {
    isOpen,
    setIsOpen,
    children,
    title,
    onClose,
    titleClass,
    showTitle = true,
  } = props;

  function closeModal() {
    return onClose ? onClose() : setIsOpen(false);
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className={tw`fixed inset-0 z-50`} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter={tw`ease-out duration-300`}
          enterFrom={tw`opacity-0`}
          enterTo={tw`opacity-100`}
          leave={tw`ease-in duration-200`}
          leaveFrom={tw`opacity-100`}
          leaveTo={tw`opacity-0`}
        >
          <div className={tw`fixed inset-0 bg-black bg-opacity-25`} />
        </Transition.Child>

        <div className={tw`fixed inset-0 overflow-y-auto`}>
          <div
            className={tw`flex min-h-full items-center justify-center p-4 text-center`}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={tw`w-fit relative z-[9999]  transform  rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
              >
                {showTitle && (
                  <Dialog.Title
                    as="h3"
                    className={tw`text-lg font-medium leading-6 text-gray-900 flex justify-between`}
                  >
                    <p className={titleClass}>{title}</p>
                    {/* <p className={tw`cursor-pointer`} onClick={closeModal}>
                      Close
                    </p> */}
                    <div
                      role={"button"}
                      tabIndex={-1}
                      className={tw`cursor-pointer`}
                      onClick={closeModal}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 6L6 18M6 6L18 18"
                          stroke="#0D0D0D"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </Dialog.Title>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
